import {
    deleteDeliveryPointLoading,
    deleteDeliveryPointRequest,
    deleteDeliveryPointSuccess,
    deleteDeliveryPointReject,
    deleteDeliveryPointReset
} from "../../actions/deliveryPoints/delete";

export const deleteDeliveryPoint = (id) => async (dispatch, getState) => {
    dispatch(deleteDeliveryPointLoading());
    try {
        const { data } = await deleteDeliveryPointRequest(getState, id);
        dispatch(deleteDeliveryPointSuccess(data))
    } catch (error) {
        dispatch(deleteDeliveryPointReject(error))
    } finally {
        setTimeout(() => { dispatch(deleteDeliveryPointReset()) }, 3000);
    }
    return Promise.resolve();
};